const Footer = () => {
  return (
    <footer className='footer'>
      <p class='copyright-footer'>developed & designed by nick ntoukas 2022</p>
    </footer>
  );
};

export default Footer;
